import { FC } from "react";
import { Anchor, Box, List, Stack, Title } from "@mantine/core";
import { useElementSize } from "@mantine/hooks";

import { Issue } from "@protos/issues/v1/issues";
import { validateUrl } from "@shared/utils";

export interface RuleReferencesProps {
  finding: Issue;
}
/**
 *
 * @param finding - a formatted finding
 * @returns - the rule's references; if there are no references, returns an empty fragment. Specifically for use with the RuleInformationCard component.
 */
export const RuleReferences: FC<RuleReferencesProps> = ({ finding }) => {
  const { ref, width } = useElementSize();
  if (finding.ruleReferences.length === 0) return null;

  return (
    <Stack gap="sm">
      <Title order={3} c="gray.6" fz="xs" tt="uppercase" fw={600}>
        References
      </Title>
      <Box
        ref={ref}
        style={{
          columns: width > 555 ? 2 : 1,
          columnGap: 30, // have to set to a high number because of List elements
        }}
      >
        <List size="sm">
          {finding.ruleReferences.map((reference) => {
            const url = validateUrl(reference);
            return (
              <List.Item key={url} lh={1.7} mr={12}>
                <Anchor
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  lineClamp={1}
                >
                  {url}
                </Anchor>
              </List.Item>
            );
          })}
        </List>
      </Box>
    </Stack>
  );
};
